export const REVIEW_LESSON_TUTOR_BOT_SYSTEM_MESSAGE_CONTENT = 'REVIEW_LESSON';
export const EXPLAIN_SCREEN_TUTOR_BOT_SYSTEM_MESSAGE_CONTENT = 'EXPLAIN_SCREEN';
export const LESSON_FEEDBACK_FORM_TUTOR_BOT_SYSTEM_MESSAGE_CONTENT = 'LESSON_FEEDBACK_FORM';
export const START_CONVERSATION_TUTOR_BOT_SYSTEM_MESSAGE_CONTENT = 'START_CONVERSATION';
export const AI_TUTOR_BRAND_NAME = 'AI Tutor';
